import React from 'react'
import {Button, Input, Badge, Label, FormGroup} from 'reactstrap'
import Loader from 'react-loader-spinner'
import {Controller, FLOW_UNITS} from '../../models'
import {getStatusesForController} from "../../api"
import { VictoryChart, VictoryAxis, VictoryArea, VictoryScatter, VictoryGroup, createContainer, VictoryBrushContainer } from 'victory'

import HourIcon from 'react-icons/lib/fa/history'
import DayIcon from 'react-icons/lib/fa/calendar-o'
import MonthIcon from 'react-icons/lib/fa/calendar'
import AllDataIcon from 'react-icons/lib/fa/archive'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'

class ControllerTrendsPanel extends React.Component {
    constructor(props) {
        super(props)
        const {token, controller, controllerID} = props

        let options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }

        let dateParts = (new Date()).toLocaleDateString('us-EN', options).split(', ')[0].split('/')
        let today = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
        let now = (new Date()).toLocaleDateString('us-EN', options).split(', ')[1]

        let yesterday = new Date()
        yesterday.setDate(yesterday.getDate()-1)
        dateParts = (yesterday).toLocaleDateString('us-EN', options).split(', ')[0].split('/')
        let yesterdayDate = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
        let yesterdayTime = `00:00`

        this.state = {
            startDateValue: yesterdayDate,
            startTimeValue: yesterdayTime,
            endDateValue: today,
            endTimeValue: now,
            activeDataPoints: ['chemical_rate', 'chemical_rate_setpoint'],
            statuses: [],
            graphLoading: false,
            errors: [],
            requestDataLoading: false,
            requestButtonText: "Request New Data",
            flowUnits: 5,
            zoomDomain: null,
            selectedDomain: null,
            controller,
            controllerID,
            token,
            chartWidth: null,
            chartHeight: null,
        }


        this.updateGraph = this.updateGraph.bind(this)
        this.removeActiveDataPoint = this.removeActiveDataPoint.bind(this)
        this.addActiveDataPoint = this.addActiveDataPoint.bind(this)
        this.handleDataPointCheckEvent = this.handleDataPointCheckEvent.bind(this)
        this.getDataFromPast = this.getDataFromPast.bind(this)
        this.getPressureMultiplier = this.getPressureMultiplier.bind(this)
        this.shouldShowFlowData = this.shouldShowFlowData.bind(this)
        this.shouldShowWaterFlowData = this.shouldShowWaterFlowData.bind(this)
	    this.shouldShowPressureData = this.shouldShowPressureData.bind(this)
        this.shouldShowPercentData = this.shouldShowPercentData.bind(this)
        this.formatDateForGraph = this.formatDateForGraph.bind(this)
        this.handleStartDateChange = this.handleStartDateChange.bind(this)
        this.handleStartTimeChange = this.handleStartTimeChange.bind(this)
        this.handleEndDateChange = this.handleEndDateChange.bind(this)
        this.handleEndTimeChange = this.handleEndTimeChange.bind(this)
        this.handleFlowUnitChange = this.handleFlowUnitChange.bind(this)

        this.filterOutIncompatibleChemFlowUnits = this.filterOutIncompatibleChemFlowUnits.bind(this)
        this.filterOutIncompatibleWaterFlowUnits = this.filterOutIncompatibleWaterFlowUnits.bind(this)
        this.convertChemRateFromUnitToUnit = this.convertChemRateFromUnitToUnit.bind(this)
        this.convertWaterRateFromUnitToUnit = this.convertWaterRateFromUnitToUnit.bind(this)
        this.updateGraphSize = this.updateGraphSize.bind(this)
    }

    async componentDidMount() {
        window.addEventListener("resize", this.updateGraphSize)
        window.addEventListener("orientationchange", this.updateGraphSize)
        if (this.state.token) {
            this.updateGraphSize()
            this.updateGraph()
        }
    }

    async componentWillUnmount() {
        window.removeEventListener("resize", this.updateGraphSize)
        window.removeEventListener("orientationchange", this.updateGraphSize)
    }

    updateGraphSize() {
        let elem = document.getElementById("chart-wrap")
        if (elem) {
            let chartWidth = elem.offsetWidth
            let chartHeight = chartWidth * 0.5
            this.setState({chartWidth, chartHeight})
        }
    }

    async componentWillReceiveProps(nextProps) {
        const {token, controller, controllerID, } = nextProps

        this.updateGraphSize()
        if (controllerID !== this.state.controllerID) {
            this.setState({
                controller,
                controllerID,
                token,
            })
            await this.updateGraph()
        } else {
            this.setState({
                controller,
                controllerID,
                token,
            })
        }

        if (token) {
            this.updateGraphSize()
            this.updateGraph()
        }
    }

    async getDataFromPast(hoursAgo=0, daysAgo=0, monthsAgo=0, yearsAgo=0, allData=false) {
        let startDateTime = new Date()
        if (allData) {
            startDateTime = new Date(0)
        } else {
            startDateTime.setHours(startDateTime.getHours() - hoursAgo)
            startDateTime.setDate(startDateTime.getDate() - daysAgo)
            startDateTime.setMonth(startDateTime.getMonth() - monthsAgo)
            startDateTime.setFullYear(startDateTime.getFullYear() - yearsAgo)
        }

        let dateToDateAndTimeString = (d) => {
            let day = String(d.getDate())
            if (day.length < 2) {
                day = `0${day}`
            }
            let month = String(d.getMonth()+1)
            if (month.length < 2) {
                month = `0${month}`
            }
            let year = String(d.getFullYear())
            let date = `${year}-${month}-${day}`

            let hours = String(d.getHours())
            if (hours.length < 2) {
                hours = `0${hours}`
            }
            let minutes = String(d.getMinutes())
            if (minutes.length < 2) {
                minutes = `0${minutes}`
            }
            let time = `${hours}:${minutes}`
            return {date, time}
        }

        let startDateValue = dateToDateAndTimeString(startDateTime).date
        let startTimeValue = dateToDateAndTimeString(startDateTime).time
        let endDateValue = dateToDateAndTimeString(new Date()).date
        let endTimeValue = dateToDateAndTimeString(new Date()).time
        //console.log(startDateValue + " " + startTimeValue + " <-> " + endDateValue + " " + endTimeValue)
	await this.setState({startDateValue, startTimeValue, endDateValue, endTimeValue})
        await this.updateGraph()
    }

    async updateGraph() {
        let startTimeParts = this.state.startTimeValue.split(":")
        let startDate = `${this.state.startDateValue}-${startTimeParts[0]}-${startTimeParts[1]}`
        let endTimeParts = this.state.endTimeValue.split(":")
        let endDate = `${this.state.endDateValue}-${endTimeParts[0]}-${endTimeParts[1]}`

        try {
            await this.setState({graphLoading: true})
            let {token, controllerID} = this.state
            let statuses = await getStatusesForController(token, controllerID, startDate, endDate)
            await this.setState({statuses, graphLoading: false, zoomDomain: null, brushDomain: null})
            this.updateGraphSize()
        } catch (error) {
            console.log(error)
            this.setState({graphLoading: false})
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({errors})
    }

    async handleStartDateChange(evt) {
        await this.setState({startDateValue: evt.target.value})
        this.updateGraph()
    }

    async handleStartTimeChange(evt) {
        await this.setState({startTimeValue: evt.target.value})
        this.updateGraph()
    }

    async handleEndDateChange(evt) {
        await this.setState({endDateValue: evt.target.value})
        this.updateGraph()
    }

    async handleEndTimeChange(evt) {
        await this.setState({endTimeValue: evt.target.value})
        this.updateGraph()
    }


    handleDataPointCheckEvent = (datapoint) => (evt) => {
        if (evt.target.checked) {
            this.addActiveDataPoint(datapoint)
        } else {
            this.removeActiveDataPoint(datapoint)
        }
    }

    addActiveDataPoint(datapoint) {
        let dp = this.state.activeDataPoints
        if (!dp.includes(datapoint)) {
            this.setState({activeDataPoints:dp.concat(datapoint)})
        }
    }

    removeActiveDataPoint(datapoint) {
        let dp = this.state.activeDataPoints
        if (dp.includes(datapoint)) {
            dp = dp.filter((val) => val !== datapoint)
            this.setState({activeDataPoints:dp})
        }
    }

    shouldShowFlowData() {
        let activeDataPoints = this.state.activeDataPoints
        return (activeDataPoints.includes("chemical_rate") || activeDataPoints.includes("chemical_rate_setpoint"))
    }


    shouldShowWaterFlowData() {
        let activeDataPoints = this.state.activeDataPoints
        return (activeDataPoints.includes("water_rate"))
    }


    shouldShowPressureData() {
        let activeDataPoints = this.state.activeDataPoints
        return (activeDataPoints.includes("chemical_pressure") || activeDataPoints.includes("water_pressure"))
    }

    shouldShowPercentData() {
        let activeDataPoints = this.state.activeDataPoints
        return activeDataPoints.includes("pwm") && !(this.shouldShowPressureData() && this.shouldShowFlowData())
    }

    getMaxChemFlow(){
        if(this.shouldShowFlowData()) {
            let flowUnits = this.state.flowUnits
            let filteredChemStatuses = this.filterOutIncompatibleChemFlowUnits(this.state.statuses, this.state.flowUnits)
            let flowVals = filteredChemStatuses.map((s) => this.convertChemRateFromUnitToUnit(s.chemical_rate, s.chemical_units, flowUnits, 1)).filter((v) => v !== null).concat(filteredChemStatuses.map((s) => this.convertChemRateFromUnitToUnit(s.chemical_rate_setpoint, s.chemical_units, flowUnits, s.running)).filter((v) => v !== null))
            return Math.max(...flowVals)
        }
        else{
            return 0
        }
    }

    getMaxWaterFlow(){
        if(this.shouldShowWaterFlowData()) {
            let flowUnits = this.state.flowUnits
            let filteredWaterStatuses = this.filterOutIncompatibleWaterFlowUnits(this.state.statuses, flowUnits)
            let waterFlowVals = filteredWaterStatuses.map((s) => this.convertWaterRateFromUnitToUnit(s.water_rate,
                s.water_units, flowUnits)).filter((v) => v !== null)
            return Math.max(...waterFlowVals)
        }
        else{
            return 0
        }

    }

    getPressureMultiplier(maxFlowVal) {
        if(maxFlowVal==0){
            return 1
        }
        let pressureVals = this.state.statuses.map((s) => s.chemical_pressure).filter((v) => v !== null).concat(this.state.statuses.map((s) => s.water_pressure).filter((v) => v !== null))
        let maxPressureVal = Math.max(...pressureVals)
	    if (maxPressureVal > 0 && maxFlowVal > 0) {
	        //console.log(maxFlowVal + " Max Flow Val   " + maxPressureVal + " Max Press")
            return (maxFlowVal / maxPressureVal)
        } else {
	        //console.log("Press Multiplier = 1")
            return 1
        }
    }

    getPercentMultiplier(maxFlowVal) {
        if(maxFlowVal==0){
            if (this.shouldShowPressureData()) {
                let pressureVals = this.state.statuses.map((s) => s.chemical_pressure).filter((v) => v !== null).concat(this.state.statuses.map((s) => s.water_pressure).filter((v) => v !== null))
                let maxPressureVal = Math.max(...pressureVals)
                let maxPercentVal = 100
                if (maxPressureVal > 0) {
                   //console.log(maxFlowVal + " Max Flow Val   " + maxPressureVal / maxPercentVal + "% Multiplier")
                    return (maxPressureVal / maxPercentVal)
                } else {
                    return 1
                }
            } else {
                //console.log("% Multiplier = 1")
                return 1
            }
        }
        else{
            //console.log(maxFlowVal + " Max Flow Val")
            let maxPercentVal = 100
            if (maxFlowVal > 0) {
                return (maxFlowVal / maxPercentVal)
            } else {
                return 1
            }
        }
    }

    formatDateForGraph(date) {
        let hours = date.getHours()
        let hourSuffix = "AM"
        if (hours > 11) {
            hours = (hours === 12 ? 12 : hours % 12)
            hourSuffix = "PM"
        }
        if (String(hours).length < 2) {
            hours = `0${hours}`
        }
        let minutes = date.getMinutes()
        if (String(minutes).length < 2) {
            minutes = `0${minutes}`
        }
        let month = date.getMonth() + 1
        if (String(month).length < 2) {
            month = `0${month}`
        }
        let day = date.getDate()
        if (String(day).length < 2) {
            day = `0${day}`
        }
        let year = String(date.getFullYear()).slice(2,4)
        return `${hours}:${minutes} ${hourSuffix} - ${month}/${day}/${year}`
    }

    filterOutIncompatibleChemFlowUnits(statuses, flowUnit) {
        let compatibilityCheck = (s) => (flowUnit < 3 ? (s.chemical_units < 3) : (s.chemical_units >= 3))
        return statuses.filter(compatibilityCheck)
    }

    filterOutIncompatibleWaterFlowUnits(statuses, flowUnit) {
        let compatibilityCheck = (s) => (flowUnit > 2)
        return statuses.filter(compatibilityCheck)
    }

    convertChemRateFromUnitToUnit(rate, fromUnit, toUnit, running) {
        if(!running){
            return 0
        }

        if (fromUnit === toUnit) {
            // no-op
            return rate
        } else if (fromUnit > 2 && toUnit <= 2) {
            // incompatible units
            return rate
        } else if (fromUnit <= 2 && toUnit > 2) {
            // incompatible units
            return rate
        }

        const mlPerOz = 29.5735
        const mlPerG = 3785.41
        const ozPerG = 128.0
        const ozPerL = 33.814
        const sqMeterPerAcre = 4046.86
        const minPerHour = 60.0
        const lPerG = 3.78541

        // area units
        // 0: 'ML/M'
        // 1: 'OZ/AC'
        // 2: 'GPA'
        if (fromUnit === 0) {
            if (toUnit === 1) {
                // mlm to ozac
                return (rate / mlPerOz) * sqMeterPerAcre
            } else if (toUnit === 2) {
                // mlm to gpa
                return (rate / mlPerG) * sqMeterPerAcre
            }
        } else if (fromUnit === 1) {
            if (toUnit === 0) {
                // ozac to mlm
                return (rate * mlPerOz) / sqMeterPerAcre
            } else if (toUnit === 2) {
                // ozac to gpa
                return rate * ozPerG
            }
        } else if (fromUnit === 2) {
            if (toUnit === 0) {
                // gpa to mlm
                return (rate * mlPerG) / sqMeterPerAcre
            } else if (toUnit === 1) {
                // gpa to ozac
                return rate / ozPerG
            }
        }

        // time units
        // 3: 'GPM'
        // 4: 'OZ/M'
        // 5: 'GPH'
        // 6: 'LPM'
        else if (fromUnit === 3) {
            if (toUnit === 4) {
                // GPM to OZ/M
                return rate * ozPerG
            } else if (toUnit === 5) {
                // GPM to GPH
                return rate * minPerHour
            } else if (toUnit === 6) {
                // GPM to LPM
                return rate * lPerG
            }
        } else if (fromUnit === 4) {
            if (toUnit === 3) {
                // OZ/M to GPM
                return rate / ozPerG
            } else if (toUnit === 5) {
                // OZ/M to GPH
                return (rate / minPerHour) / ozPerG
            } else if (toUnit === 6) {
                // OZ/M to LPM
                return rate * mlPerOz
            }
        } else if (fromUnit === 5) {
            if (toUnit === 3) {
                // GPH to GPM
                return rate / minPerHour
            } else if (toUnit === 4) {
                // GPH to OZ/M
                return (rate / minPerHour) * ozPerG
            } else if (toUnit === 6) {
                // GPH to LPM
                return rate / minPerHour * lPerG
            }
        } else if (fromUnit === 6) {
            if (toUnit === 3) {
                // LPM to GPM
                return rate / lPerG
            } else if (toUnit === 4) {
                // LPM to OZ/M
                return rate*ozPerL
            } else if (toUnit === 5) {
                // LPM to GPH
                return (rate / lPerG) / minPerHour
            }
        }

        return rate
    }

    convertWaterRateFromUnitToUnit(rate, fromUnit, toUnit) {
        const litersPerGal = 3.78541
        const ozPerLiter = 33.814
        const ozPerGal = 128.0
        const minPerHour = 60.0

        if (fromUnit === 0 && toUnit === 6 || fromUnit === 1 && toUnit === 3) {
            // no need to convert water unit, already good to go
            return rate
        }

        if (fromUnit === 0) {
            // from Liters
            if (toUnit === 3) {
                // LitersPerMin to GPM
                return rate * litersPerGal
            } else if (toUnit === 4) {
                // LitersPerMin to OZM
                return rate / ozPerLiter
            } else if (toUnit === 5) {
                // LitersPerMin to GPH
                return rate * litersPerGal * minPerHour
            } else {
                // not sure what to do with this?
                return rate
            }
        } else {
            // from Gal
            if (toUnit === 4) {
                // GalPerMin to OZM
                return rate / ozPerGal
            } else if (toUnit === 5) {
                // GPM to GPH
                return rate * minPerHour
            } else if (toUnit === 6) {
                // GPM to LPM
                return rate / litersPerGal
            } else {
                // not sure what to do with this?
                return rate
            }
        }
    }

    async handleFlowUnitChange(evt) {
        await this.setState({flowUnits: parseInt(evt.target.value)})
        this.updateGraph()
    }

    handleZoom(domain) {
        this.setState({selectedDomain: domain})
    }

    handleBrush(domain) {
        this.setState({zoomDomain: domain})
    }

    render() {
        let controller = this.state.controller || new Controller()
        let {graphLoading, activeDataPoints, statuses,
            zoomDomain, selectedDomain, startDateValue, startTimeValue, endDateValue, endTimeValue,
            flowUnits, chartWidth, chartHeight} = this.state
        let statusesWithCompatibleChemUnits = this.filterOutIncompatibleChemFlowUnits(statuses, flowUnits)
        let statusesWithCompatibleWaterUnits = this.filterOutIncompatibleWaterFlowUnits(statuses, flowUnits)
        let unableToConvertAllUnits = (statusesWithCompatibleChemUnits.length && statusesWithCompatibleWaterUnits && statuses.length && statuses.length > (statusesWithCompatibleChemUnits.length + statusesWithCompatibleWaterUnits))
        let maxChemFlow = this.getMaxChemFlow()
        let maxWaterFlow = this.getMaxWaterFlow()
        let chemRateMultiplier = 1
        let waterRateMultiplier = 1
        let maxFlowRate = (maxChemFlow>maxWaterFlow ? maxChemFlow : maxWaterFlow)
        let pressureMultiplier = this.getPressureMultiplier(maxFlowRate)
        let percentMultiplier = this.getPercentMultiplier(maxFlowRate)
        let showFlowData = this.shouldShowFlowData()
        let showWaterFlowData = this.shouldShowWaterFlowData()
	    let showPressureData = this.shouldShowPressureData()
        let showPercentData = this.shouldShowPercentData()
        let dataVisible = ((showWaterFlowData || showFlowData || showPressureData || showPercentData) && statuses && statuses.length)
        const VictoryZoomVoronoiContainer = createContainer("zoom", "voronoi")

        //We need to show flow on two different axis since no press or percent
        if(showWaterFlowData && showFlowData && showPressureData == 0 && showPercentData==0){
            if(maxChemFlow>maxWaterFlow) {
                waterRateMultiplier = maxChemFlow / maxWaterFlow
            } else {
                chemRateMultiplier = maxWaterFlow / maxChemFlow
            }
        }

	//console.log("Chem Mult: " + chemRateMultiplier + "   Water Mult: " + waterRateMultiplier)
	//console.log("Press Mult: " + pressureMultiplier + "   Pcnt Mult: " + percentMultiplier)
        let safelyParseDate = (s) => {
            try {
                const str = s.replace("Z", "")
                const dateTime = str.split('T')
                const dateBits = dateTime[0].split('-')
                const timeBits = dateTime[1].split(':')
                return new Date(dateBits[0], parseInt(dateBits[1]) - 1, dateBits[2], timeBits[0], timeBits[1], timeBits[2])
            } catch (e) {
                return null
            }
        }

        const chemicalFlowData = statusesWithCompatibleChemUnits.map((s) => {
            const time = safelyParseDate(s.local_datetime).getTime()
            const chemical_rate = this.convertChemRateFromUnitToUnit(s.chemical_rate, s.chemical_units, flowUnits, 1) * chemRateMultiplier
            const chemical_setpoint = this.convertChemRateFromUnitToUnit(s.chemical_rate_setpoint, s.chemical_units, flowUnits, s.running) * chemRateMultiplier
            return { chemicalRateScatter: {
                    time: time,
                    val: chemical_rate,
                    category: "Chemical Rate",
                    units: FLOW_UNITS[flowUnits],
                },
                chemicalRateArea: {
                    x: time,
                    y: chemical_rate
                },
                chemicalRateSetpointScatter: {
                    time: time,
                    val: chemical_setpoint,
                    category: "Chemical Rate Setpoint",
                    units: FLOW_UNITS[flowUnits]
                },
                chemicalRateSetpointArea: {
                    x: time,
                    y: chemical_setpoint
                }
            }
        })
        const chemicalRateAreaData = chemicalFlowData.map((d) => d.chemicalRateArea)
        const chemicalRateScatterData = chemicalFlowData.map((d) => d.chemicalRateScatter)
        const chemicalRateSetpointAreaData = chemicalFlowData.map((d) => d.chemicalRateSetpointArea)
        const chemicalRateSetpointScatterData = chemicalFlowData.map((d) => d.chemicalRateSetpointScatter)
        const waterRateData = statusesWithCompatibleWaterUnits.map((s) => {
            const time = safelyParseDate(s.local_datetime).getTime()
            const water_rate = this.convertWaterRateFromUnitToUnit(s.water_rate, s.water_units, flowUnits) * waterRateMultiplier
            return {
                scatter:{
                    time: time,
                    val: water_rate,
                    category: "Water Rate",
                    units: FLOW_UNITS[flowUnits]
                },
                area:{
                    x: time,
                    y: water_rate
                }
            }
        })
        const waterRateAreaData = waterRateData.map((d) => d.area)
        const waterRateScatterData = waterRateData.map((d) => d.scatter)
        const otherData = statuses.map((s) => {
            const time = safelyParseDate(s.local_datetime).getTime()
            const chemical_pressure = s.chemical_pressure*pressureMultiplier
            const water_pressure = s.water_pressure*pressureMultiplier
            const pwm = s.pwm*1*s.running * percentMultiplier
            return {
                chemicalPressureScatter: {
                    time: time,
                    converted_val: chemical_pressure,
                    category: "Chemical Pressure",
                    units: "PSI",
                    val: s.chemical_pressure
                },
                chemicalPressureArea: {
                    x: time,
                    y: chemical_pressure
                },
                waterPressureScatter: {
                    time: time,
                    val: s.water_pressure,
                    category: "Water Pressure",
                    units: "PSI",
                    converted_val: water_pressure
                },
                waterPressureArea: {
                    x: time,
                    y: water_pressure
                },
                pwmScatter: {
                    time: time,
                    converted_val: pwm,
                    category: "PWM",
                    units: "%",
                    val: s.pwm
                },
                pwmArea: {
                    x: time,
                    y: pwm
                }
            }
        })
        const chemicalPressureAreaData = otherData.map((d) => d.chemicalPressureArea)
        const chemicalPressureScatterData = otherData.map((d) => d.chemicalPressureScatter)
        const waterPressureAreaData = otherData.map((d) => d.waterPressureArea)
        const waterPressureScatterData = otherData.map((d) => d.waterPressureScatter)
        const pwmAreaData = otherData.map((d) => d.pwmArea)
        const pwmScatterData = otherData.map((d) => d.pwmScatter)

        let xPadding = 10000
        if (statuses.length > 1) {
            let dates = statuses.map((s)=>safelyParseDate(s.local_datetime).getTime())
            let max = Math.max(...dates)
            let min = Math.min(...dates)
            xPadding = ((max - min) / max) * xPadding
        }


        return <div className="col-12 no-gutters">
            <div className="col-12 offset-0 col-md-8 offset-md-2 mt-2 align-items-start no-gutters">
                <div className="col-12 align-content-start">
                    <Label className="col-7 pl-1 mb-0 small text-left" for="startDate">Start Date</Label>
                    <Label className="col-5 pl-1 mb-0 small text-left" for="startTime">Start Time</Label>
                    <Input name="startDate" value={startDateValue} className="col-7 pl-1 pr-1 d-inline-block" type="date" onChange={this.handleStartDateChange}/>
                    <Input name="startTime" value={startTimeValue} className="col-5 pl-1 pr-1 d-inline-block" type="time" onChange={this.handleStartTimeChange}/>
                </div>
                <div className="col-12 align-content-start">
                    <Label className="col-7 pl-1 mb-0 small text-left" for="endDate">End Date</Label>
                    <Label className="col-5 pl-1 mb-0 small text-left" for="endTime">End Time</Label>
                    <Input name="endDate" value={endDateValue} className="col-7 pl-1 pr-1 d-inline-block" type="date" onChange={this.handleEndDateChange}/>
                    <Input name="endTime" value={endTimeValue} className="col-5 pl-1 pr-1 d-inline-block" type="time" onChange={this.handleEndTimeChange}/>
                </div>
            </div>
            <div className="col-12 mt-2 no-gutters">
                <Button onClick={(evt)=>this.getDataFromPast(1)} className="col-5 col-lg-3 bg-light-sf-orange m-1"><HourIcon/>&ensp;Last Hour</Button>
                <Button onClick={(evt)=>this.getDataFromPast(3)} className="col-5 col-lg-3 bg-light-sf-orange m-1"><HourIcon/>&ensp;Last 3 Hours</Button>
                <Button onClick={(evt)=>this.getDataFromPast(0,1)} className="col-5 col-lg-3 bg-light-sf-orange m-1"><DayIcon/>&ensp;Last Day</Button>
                <Button onClick={(evt)=>this.getDataFromPast(0,7)} className="col-5 col-lg-3 bg-light-sf-orange m-1"><MonthIcon/>&ensp;Last Week</Button>
                <Button onClick={(evt)=>this.getDataFromPast(0,0,1)} className="col-5 col-lg-3 bg-light-sf-orange m-1"><MonthIcon/>&ensp;Last Month</Button>
                <Button onClick={(evt)=>this.getDataFromPast(0,0,0,30)} className="col-5 col-lg-3 bg-light-sf-orange m-1"><AllDataIcon/>&ensp;All Data</Button>
            </div>
            <div className="chart-container d-block bg-white rounded col-12 col-xl-10 offset-0 offset-xl-1 mt-4 mb-4 pt-0 pb-0 pl-4 pr-2">
                    {dataVisible && !graphLoading ?
                    <div id="chart-wrap" className="col-12 m-0 p-0">
                    <VictoryChart
                    padding={{top: 10, bottom: 35, left: 60, right: 60}}
                    width={chartWidth}
                    height={chartHeight}
                    domainPadding={{x:[xPadding, xPadding], y: [0,10]}}
                    containerComponent={
                    <VictoryZoomVoronoiContainer
                    labels={(d) => (d.category && d.time ? `${d.category}: ${Math.round(d.val, 2)} ${d.units} — ${this.formatDateForGraph(new Date(d.time))}`: null)}
                    responsive={false}
                    zoomDimension="x"
                    onZoomDomainChange={this.handleZoom.bind(this)}
                    zoomDomain={zoomDomain}
                    />
                    }>
                    <VictoryAxis
                    fixLabelOverlap={true}
                    scale={{ x: "time" }}
                    style={{grid:{stroke:"#ededed", strokeWidth:1}, ticks: {stroke: "#ededed", size: 1, strokeWidth: 1}}}
                    />
                    {((showFlowData || showWaterFlowData) ?
                    <VictoryAxis
                    dependentAxis
                    tickFormat={(y) => ((flowUnits === 0 || flowUnits === 1 || flowUnits === 4) ? `${Math.round(y/1000)}k ${FLOW_UNITS[flowUnits]}`: `${Math.round(y/chemRateMultiplier)} ${FLOW_UNITS[flowUnits]}`)}
                    style={{grid:{stroke:"#ededed", strokeWidth:1}, ticks: {stroke: "#ededed", size: 1, strokeWidth: 1}}}
                    />: null)}
                    {((showFlowData && showWaterFlowData && showPressureData==0 && showPercentData==0) ?
                    <VictoryAxis
                    dependentAxis
                    orientation="right"
                    tickFormat={(y) => ((flowUnits === 0 || flowUnits === 1 || flowUnits === 4) ? `${Math.round(y/1000)}k ${FLOW_UNITS[flowUnits]}`: `${Math.round(y/waterRateMultiplier)} ${FLOW_UNITS[flowUnits]}(W)`)}
                    style={{grid:{stroke:"#ededed", strokeWidth:1}, ticks: {stroke: "#ededed", size: 1, strokeWidth: 1}}}
                    />: null)}

                    {(showPressureData ?
                    <VictoryAxis
                    dependentAxis
                    orientation={((showFlowData || showWaterFlowData) ? "right" : "left")}
                    tickFormat={(y) => (`${Math.round(y/pressureMultiplier)} psi`)}
                    style={{grid:{stroke:"#ededed", strokeWidth:1}, ticks: {stroke: "#ededed", size: 1, strokeWidth: 1}}}
                    />: null)}
                    {(showPercentData ?
                    <VictoryAxis
                    dependentAxis
                    orientation={((showFlowData || showWaterFlowData) || showPressureData ? "right" : "left")}
                    tickFormat={(y) => (`${Math.round(y/percentMultiplier)}%`)}
                    style={{grid:{stroke:"#ededed", strokeWidth:1}, ticks: {stroke: "#ededed", size: 1, strokeWidth: 1}}}
                    />: null)}

                    {(activeDataPoints.includes("chemical_rate") ?
                    <VictoryGroup>
                    <VictoryArea
                    data={chemicalRateAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "green", stroke: "green", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    <VictoryScatter
                    data={chemicalRateScatterData}
                    x="time"
                    y="val"
                    style={{ data: { fill: "green", stroke: "darkgreen", strokeWidth: 3 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    </VictoryGroup> : null)}

                    {(activeDataPoints.includes("chemical_rate_setpoint") ?
                    <VictoryGroup>
                    <VictoryArea
                    data={chemicalRateSetpointAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "olive", stroke: "olive", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    <VictoryScatter
                    data={chemicalRateSetpointScatterData}
                    x="time"
                    y="val"
                    style={{ data: { fill: "olive", stroke: "darkolivegreen", strokeWidth: 3 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    </VictoryGroup> : null)}

                    {(activeDataPoints.includes("chemical_pressure") ?
                    <VictoryGroup>
                    <VictoryArea
                    data={chemicalPressureAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "teal", stroke: "teal", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    <VictoryScatter
                    data={chemicalPressureScatterData}
                    x="time"
                    y="converted_val"
                    style={{ data: { fill: "teal", stroke: "darkteal", strokeWidth: 3 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    </VictoryGroup> : null)}

                    {(activeDataPoints.includes("water_rate") ?
                    <VictoryGroup>
                    <VictoryArea
                    data={waterRateAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "blue", stroke: "blue", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    <VictoryScatter
                    data={waterRateScatterData}
                    x="time"
                    y="val"
                    style={{ data: { fill: "blue", stroke: "darkblue", strokeWidth: 3 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    </VictoryGroup> : null)}

                    {(activeDataPoints.includes("water_pressure") ?
                    <VictoryGroup>
                    <VictoryArea
                    data={waterPressureAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "purple", stroke: "purple", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    <VictoryScatter
                    data={waterPressureScatterData}
                    x="time"
                    y="converted_val"
                    style={{ data: { fill: "purple", stroke: "darkpurple", strokeWidth: 3 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    </VictoryGroup> : null)}

                    {(activeDataPoints.includes("pwm") ?
                    <VictoryGroup>
                    <VictoryArea
                    data={pwmAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "orange", stroke: "orange", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    <VictoryScatter
                    data={pwmScatterData}
                    x="time"
                    y="converted_val"
                    style={{ data: { fill: "orange", stroke: "darkorange", strokeWidth: 3 } }}
                    scale={{x: "time", y: "linear"}}
                    />
                    </VictoryGroup> : null)}
                    </VictoryChart>
                    <hr/>
                    <small>Data Overview</small>
                    <VictoryChart
                    padding={{top: 0, left: 50, right: 50, bottom: 30}}
                    domainPadding={{x:[xPadding, xPadding], y: [0,10]}}
                    width={chartWidth} height={(chartHeight < 180 ? 60 : chartHeight/4)} scale={{x: "time"}}
                    className="offset-2"
                    containerComponent={
                    <VictoryBrushContainer responsive={false}
                    brushDimension="x"
                    onBrushDomainChange={this.handleBrush.bind(this)}
                    brushDomain={selectedDomain}
                    />}>
                    <VictoryAxis
                    fixLabelOverlap={true}
                    />
                    <VictoryAxis
                    dependentAxis
                    tickFormat={(y) => ""}
                    />
                    {(activeDataPoints.includes("chemical_rate") ?
                    <VictoryArea
                    data={chemicalRateAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "green", stroke: "green", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    />: null)}
                    {(activeDataPoints.includes("chemical_rate_setpoint") ?
                    <VictoryArea
                    data={chemicalRateSetpointAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "olive", stroke: "olive", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    /> : null)}

                    {(activeDataPoints.includes("chemical_pressure") ?
                    <VictoryArea
                    data={chemicalPressureAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "teal", stroke: "teal", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    /> : null)}

                    {(activeDataPoints.includes("water_rate") ?
                    <VictoryArea
                    data={waterRateAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "blue", stroke: "blue", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    /> : null)}

                    {(activeDataPoints.includes("water_pressure") ?
                    <VictoryArea
                    data={waterPressureAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "purple", stroke: "purple", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    /> : null)}

                    {(activeDataPoints.includes("pwm") ?
                    <VictoryArea
                    data={pwmAreaData}
                    interpolation="stepAfter"
                    style={{ data: { fill: "orange", stroke: "orange", strokeWidth: 3, fillOpacity: 0.2, strokeOpacity: 0.6 } }}
                    scale={{x: "time", y: "linear"}}
                    /> : null)}
                    </VictoryChart>
                    </div>:
                    <div className="h-100 w-100 d-table mt-4 pt-4">
                    {(graphLoading ? <span className="d-table-cell align-middle"><Loader type="TailSpin" color="orange" width={60} height={60}/></span> :
                    <h3 className="text-muted d-table-cell align-middle pt-4"><br/><br/>No Data</h3>)}
                    </div>}
                </div>
                {(unableToConvertAllUnits ?
                    <div className="mb-4">
                        <small className="bg-warning p-1 rounded">Some flow data not shown. Cannot convert {(flowUnits < 3 ? "'Flow Per Time'" : "'Flow Per Area'")} measurement to {(FLOW_UNITS[flowUnits])}.</small>
                        <br/>
                        <small>To view this data, please select flow units measured by {(flowUnits < 3 ? "time" : "area")} such as {(flowUnits < 3 ? "GPH, GPM" : "GPA, OZ/AC")}, etc.</small>
                    </div> : null)}
                <div className="col-12 no-gutters mt-0 mb-4">
                    {(controller.lastUpdatedGMT ?
                        <div className="text-muted col-12 no-gutters">
                            <small className="col-12 d-block d-md-inline-block col-md-5 text-center text-md-right">
                                Controller&nbsp;Last&nbsp;Updated&nbsp;
                                {(controller.lastUpdatedGMT ?
                                    controller.lastUpdatedTimeString:
                                    null)}&nbsp;
                                {(controller.lastUpdatedGMT ?
                                    controller.lastUpdatedDateString:
                                    "Never")}
                            </small>
                            <small className="d-none d-md-inline-block">
                                &emsp;|&emsp;
                            </small>
                            <small className="col-12 d-block d-md-inline-block col-md-5 text-center text-md-left">
                                Local&nbsp;Time&nbsp;
                            {(controller.localDateTime ?
                                controller.localTimeString:
                                null)}&nbsp;
                            {(controller.localDateTime ?
                                controller.localDateString:
                                "Unknown")}
                            </small>
                        </div>:
                        <span className="text-warning">
                                        <WarningIcon/>&nbsp;No Data From Controller.
                                    </span>)}
                </div>
                <hr/>
                <div className="row col-12 no-gutters mt-3">
                    <div className="col-12 offset-0 offset-md-1 col-md-8 mb-3">
                        <div className="text-left col-12 col-md-6 d-inline-block">
                            <Label>Data Points</Label>
                            <br/>
                            {(showPressureData && showPercentData ?
                                    <span>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"gray", opacity: 0.6}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input className="disabled" type="checkbox" checked={false} onChange={(evt)=>(evt)} disabled/>Chemical Rate
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"gray", opacity: 0.6}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input className="disabled" type="checkbox" checked={false} onChange={(evt)=>(evt)} disabled/>Chemical Rate Setpoint
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"gray", opacity: 0.6}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input className="disabled" type="checkbox" checked={false} onChange={(evt)=>(evt)} disabled/> Water Rate
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                            </span>:
                                    <span>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"green"}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" checked={activeDataPoints.includes("chemical_rate")} onChange={this.handleDataPointCheckEvent("chemical_rate")}/>Chemical Rate
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"olive"}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" checked={activeDataPoints.includes("chemical_rate_setpoint")} onChange={this.handleDataPointCheckEvent("chemical_rate_setpoint")}/>Chemical Rate Setpoint
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"blue"}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" checked={activeDataPoints.includes("water_rate")} onChange={this.handleDataPointCheckEvent("water_rate")}/> Water Rate
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                            </span>
                            )}
                            {((showFlowData || showWaterFlowData) && showPercentData ?
                                    <span>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"gray", opacity: 0.6}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input className="disabled" type="checkbox" checked={false} onChange={(evt)=>(evt)} disabled/> Chemical Pressure
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"gray", opacity: 0.6}}>
                                    <FormGroup check>
                                        <Label check>
                                            <Input className="disabled" type="checkbox" checked={false} onChange={(evt)=>(evt)} disabled/> Water Pressure
                                        </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                            </span>:
                                    <span>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"teal"}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" checked={activeDataPoints.includes("chemical_pressure")} onChange={this.handleDataPointCheckEvent("chemical_pressure")}/> Chemical Pressure
                                            </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                                <div className="m-1 d-inline-block">
                                    <Badge className="p-2" style={{backgroundColor:"purple"}}>
                                    <FormGroup check>
                                        <Label check>
                                            <Input type="checkbox" checked={activeDataPoints.includes("water_pressure")} onChange={this.handleDataPointCheckEvent("water_pressure")}/> Water Pressure
                                        </Label>
                                        </FormGroup>
                                    </Badge>
                                </div>
                            </span>
                            )}
                            <div className="m-1 d-inline-block">
                                {((showFlowData || showWaterFlowData) && showPressureData ?
                                    <Badge className="p-2" style={{backgroundColor:"gray", opacity: 0.6}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input className="disabled" type="checkbox" checked={false} onChange={(evt)=>(evt)} disabled/> PWM
                                            </Label>
                                        </FormGroup>
                                    </Badge>:
                                    <Badge className="p-2" style={{backgroundColor:"orange"}}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" checked={activeDataPoints.includes("pwm")} onChange={this.handleDataPointCheckEvent("pwm")}/> PWM
                                            </Label>
                                        </FormGroup>
                                    </Badge>)}
                            </div>
                        </div>
                        <div className="col-12 col-md-6 text-left d-inline-block align-top mt-2">
                            <Label>Flow Units</Label>
                            <Input type="select" value={flowUnits} onChange={this.handleFlowUnitChange}>
                                {[0,1,2,3,4,5].map((val) =>
                                    <option key={`flow-units-opt-${val}`} value={val}>
                                        {FLOW_UNITS[val]}
                                    </option>
                                )}
                            </Input>
                        </div>
                    </div>
            </div>
        </div>
    }
}

export default ControllerTrendsPanel




// WEBPACK FOOTER //
// ./src/components/ui/ControllerTrendsPanel.js